import alertify from 'alertifyjs'
import {fromMaybe} from '@freckle/maybe'

type NotificationTypeT = 'error' | 'success' | 'default'

const Notification = {
  displayErrorNotification(message: string, wait?: number | null, callback?: (() => void) | null) {
    Notification.displayNotification('error', message, wait, callback)
  },

  displaySuccessNotification(
    message: string,
    wait?: number | null,
    callback?: (() => void) | null,
  ) {
    Notification.displayNotification('success', message, wait, callback)
  },

  displayNotification(
    type: NotificationTypeT | undefined | null,
    message: string,
    wait?: number | null,
    callback?: (() => void) | null,
  ) {
    alertify.set('notifier', 'position', 'top-right')
    const paramType = fromMaybe(() => 'default', type)
    const paramWait = fromMaybe(() => 2, wait)
    const paramCallback = callback ?? null
    alertify.notify(message, paramType, paramWait, paramCallback)
  },
}

export default Notification
